module.exports = {
  src: __webpack_public_path__ + "static/media/weddings_00001.7c798671.jpg",
  width: 2000,
  height: 2500,
  bytes: 214945,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/weddings_00001.7c798671.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/weddings/weddings_00001.jpg
// module id = 487
// module chunks = 0